var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167908",
    "data-name": "Group 167908",
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51369",
    "data-name": "Path 51369",
    d: "M17.986,8.1C14.223,12.86,7.248,14.4,7.248,14.4a1.023,1.023,0,0,1-1.217-.618.856.856,0,0,1,.721-1.043s6.642-1.443,9.889-6.012l-1.967-.015a.934.934,0,0,1-.991-.865A.94.94,0,0,1,14.692,5l4.28.033a.935.935,0,0,1,.991.849L20,9.466a1.012,1.012,0,0,1-2,.015ZM10.485,26H6a1.874,1.874,0,0,1-2-1.714v-4.93a1.874,1.874,0,0,1,2-1.714h4.485Zm1.883-9.929A1.906,1.906,0,0,1,14.4,14.327H17.28a1.906,1.906,0,0,1,2.035,1.744L19.432,26H12.485Zm9.064-3.543a1.906,1.906,0,0,1,2.034-1.744H26A1.874,1.874,0,0,1,28,12.5V24.286A1.874,1.874,0,0,1,26,26H21.432Z",
    transform: "translate(0 0)",
    fill: "#5460d1",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/Analysis.7be8ededfe3794b8cae0713cc8723f23.svg";
export { ForwardRef as ReactComponent };